import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { RichTextField } from '@prismicio/client';
import { memo } from 'react';
import styles from './animatedListTitle.module.scss';

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={`${styles.title}`}>{children}</h2>,
};

interface AnimatedListTitleProps {
  title: RichTextField;
  isVisible: boolean;
}

const AnimatedListTitleComponent = ({
  title,
  isVisible,
}: AnimatedListTitleProps) => {
  return (
    <div className={`${styles.container} ${isVisible ? styles.isActive : ''}`}>
      <PrismicRichText field={title} components={components} />
    </div>
  );
};

export const AnimatedListTitle = memo(AnimatedListTitleComponent);
